import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import { DIRECTION } from './constants';

const ModalButtonGroup = ({ direction = DIRECTION.left, children }) => {
  const [firstChild, secondChild, thirdChild] = React.Children.toArray(children);
  const isMobile = bowser.mobile;

  const classes = classNames('ws-ui-modal-button-group', `ws-ui-modal-button-group--${direction}`, {
    'ws-ui-modal-button-group--mobile': isMobile,
  });

  return (
    <div className={classes}>
      <div className="ws-ui-modal-button-group__wrapper">
        {firstChild}
        {secondChild}
      </div>
      {thirdChild}
    </div>
  );
};

ModalButtonGroup.propTypes = {
  direction: PropTypes.oneOf(Object.values(DIRECTION)),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ModalButtonGroup;
